import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { useTableContext } from '#/hooks/useTableContext';

import Paginate from '#/modules/commonComponents/table/Paginate';

const TablePagination = ({ containerClassName = null }) => {
  const { currentPage, totalPages, totalCount, handlePageChange } = useTableContext();

  function handlePageChangeWrapper({ selected }) {
    handlePageChange(selected + 1);
  }

  return (
    <div
      className={cn(
        'flex shrink-0 flex-col items-center justify-between gap-2 border-t border-gray-500 p-5',
        'shortcut_transition',
        '@lg/table-panel:flex-row @lg/table-panel:gap-5',
        containerClassName
      )}
    >
      <Paginate
        pageCount={totalPages}
        onPageChange={handlePageChangeWrapper}
        forcePage={(currentPage ?? 1) - 1}
      />
      <p className="table-pagination__total text-gray-400">
        共 <span className="table-pagination__count font-bold text-gray-500">{totalCount}</span> 筆
      </p>
    </div>
  );
};

TablePagination.propTypes = {
  containerClassName: PropTypes.string,
};

export default TablePagination;
